import useTranslation from 'next-translate/useTranslation';

// Lib
import { showOptions } from '@/lib/reports/tableConfigs/tableFilters';

// Components
import Select from '@/components/base/Select';

// Types
import type {
    RequestParamsType,
    SetRequestParamsType
} from '@/utils/hooks/swr/reports/useFetchReports';

type OptionType = {
    label: ReturnType<typeof showOptions>[number]['label'];
    value: ReturnType<typeof showOptions>[number]['value'];
};

const SelectShowFilter = ({
    requestParams,
    setRequestParams
}: {
    requestParams: RequestParamsType;
    setRequestParams: SetRequestParamsType;
}) => {
    const { t } = useTranslation();
    const options = showOptions(t);
    const defaultOption = requestParams?.per_page ?? parseInt(options[0]?.value);

    return (
        <Select
            options={options as unknown as OptionType[]}
            buttonBaseStyle="noBorder"
            className="w-full @2xl:w-44"
            setSelected={(option: OptionType) => {
                setRequestParams((prevState) => ({
                    ...prevState,
                    page: 1,
                    per_page: parseInt(option.value)
                }));
            }}
            selected={options?.filter((option) => parseInt(option.value) === defaultOption)?.[0]}
            data-testid="select-show-filter"
        />
    );
};

export default SelectShowFilter;
